import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import UrgencyBar from '@/components/feature/UrgencyBar';
import MobileStickyBar from '@/components/feature/MobileStickyBar';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import TurnkeySection from './components/TurnkeySection';
import GuaranteeSection from './components/GuaranteeSection';
import ResultSection from './components/ResultSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <UrgencyBar />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <WhyChooseUs />
        <TurnkeySection />
        <TestimonialsSection />
        <GuaranteeSection />
        <ResultSection />
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}
